var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "99g7pvjkgc",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#25B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1080FF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "isgiebedna",
    width: "112.3%",
    height: "124.4%",
    x: "-6.2%",
    y: "-8.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.100685009 0 0 0 0 0.100685009 0 0 0 0 0.100685009 0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "9cidhkec8b",
    d: "M23.936 35.62c-.312 0-.536-.01-.673-.03-.097 1.284-.34 2.389-.73 3.313-.39.925-.955 1.79-1.695 2.598-.74.808-1.773 1.747-3.098 2.817l-3.01-3.911.269-.24c.874-.789 1.515-1.448 1.922-1.979.449-.584.731-1.163.848-1.737.117-.574.175-1.396.175-2.466V23.768h5.378v5.546l.006.112c.017.143.069.262.155.355.107.117.258.175.453.175h3.214l.112-.007c.142-.018.256-.075.341-.168.108-.117.161-.272.161-.467v-5.546h5.378v5.546l.006.112c.017.143.069.262.155.355.107.117.258.175.453.175h3.156l.091-.007c.119-.018.225-.075.318-.168.117-.117.175-.263.175-.438V15.682h5.378v14.011l-.008.32c-.047.948-.308 1.829-.781 2.643-.526.905-1.237 1.625-2.134 2.16-.896.536-1.89.803-2.98.803h-3.215l-.295-.004c-.579-.02-1.09-.096-1.532-.23-.516-.155-1.008-.408-1.476-.758-.468.35-.96.603-1.476.759-.516.155-1.125.233-1.827.233zm24.55-16.23l7.452 5.166.259.209c.672.561 1.19 1.153 1.553 1.776.41.7.614 1.576.614 2.627 0 1.226-.297 2.33-.892 3.313-.594.983-1.398 1.752-2.41 2.306-1.014.555-2.115.832-3.303.832H44.48v-5.663h7.745l.122-.004c.425-.031.638-.234.638-.609 0-.155-.058-.287-.175-.394-.117-.107-.39-.306-.819-.598l-6.575-4.525 3.068-4.437zM34.982 42.48v-4.525h-9.06v4.524h9.06zm-29.43 1.838c2.571-1.09 4.51-2.102 5.816-3.036 1.305-.934 2.23-2.009 2.776-3.225.546-1.217.818-2.827.818-4.831v-4.058c0-1.245-.277-2.394-.833-3.444-.555-1.051-1.325-1.883-2.308-2.496-.984-.613-2.09-.92-3.318-.92-1.247 0-2.391.307-3.434.92-1.042.613-1.875 1.445-2.498 2.496-.624 1.05-.936 2.199-.936 3.444 0 1.226.307 2.33.921 3.313.614.983 1.447 1.752 2.499 2.306 1.052.555 2.201.832 3.448.832h1.082c0 .39-.127.745-.38 1.066-.253.32-.79.71-1.608 1.167-.818.458-2.055 1.037-3.711 1.737l1.666 4.73zm4.033-14.011H8.504c-.35 0-.638-.103-.862-.307-.224-.204-.336-.482-.336-.832 0-.37.112-.662.336-.876.224-.214.512-.32.862-.32.332 0 .595.106.79.32.194.214.292.506.292.876v1.139z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1176) translate(52) translate(1124)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#isgiebedna)",
    xlinkHref: "#9cidhkec8b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#99g7pvjkgc)",
    xlinkHref: "#9cidhkec8b"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliro);
export default __webpack_public_path__ + "static/media/deliro.89b5f966562b49fe78b7f47bf9ac805e.svg";
export { ForwardRef as ReactComponent };